export const mailPixel = (type, goal, value = null) => {

    if (typeof window !== "undefined") {
        let _tmr = window._tmr || (window._tmr = []);

        const payload = {
            type,
            goal,
            'id': localStorage.getItem('mail_visitors_counter_id')
        };

        if (value !== null) {
            payload.value = value
        }

        console.log(payload)

        _tmr.push(payload);
    }

}
